import tooltipNamntryck from '../../../../assets/cls-se/products/pdp-tooltips/tryk-navn-logo.jpg';
import tooltipSpecialTekst from '../../../../assets/cls-se/products/pdp-tooltips/example_special-tekst.jpg';
import tooltipFlag from '../../../../assets/cls-se/products/pdp-tooltips/example_flag_print.jpg';
import tooltipBogstav from '../../../../assets/cls-se/products/pdp-tooltips/example_klassens_bogstav.jpg';
import tooltipBrösttryck from '../../../../assets/cls-se/products/pdp-tooltips/example_lille_brysttryk.jpg';
import tooltipRyggtryck from '../../../../assets/cls-se/products/pdp-tooltips/rygtryk_a4.jpg';

export const ADDON_TOOLTIPS = {
  navnetryk: {
    title: 'Eksempel navnetryk',
    image: tooltipNamntryck,
    description: 'Her har du mulighed for at få navnetryk. Der kan max. fyll ies 16 tecken inkl. mellanslag. Navnet blir placeret på ena bröstet. Observera, specialtecken som kinesiska m.m er ikke muligt.\n\n(Kontrollera om ditt navn er stavat korrekt - både her och på den teckening, som laves til rygtryk)',
  },
  specialTekst: {
    title: 'Eksempel speciel tekst',
    image: tooltipSpecialTekst,
    description: 'T.ex. navn på Instagram eller smeknamn. Teksten blir trykt på ärmen. Max 16 tecken inkl. mellanslag.',
  },
  flag: {
    title: 'Eksempel flag',
    image: tooltipFlag,
    description: 'Välj et flag der blir trykt på ärmen af din tröja. Flaget er ca. 3×2 cm.',
  },
  klassensBogstav: {
    title: 'Eksempel klassns bokstav',
    image: tooltipBogstav,
    description: 'Klassns bokstav blir broderad på ärmen. Välj det bokstav der passar til din klass.',
  },
  lilleBrösttryck: {
    title: 'Eksempel lille brysttryk',
    image: tooltipBrösttryck,
    description: 'Skolens logo eller eget logo (Tryk) blir placeret på bröstet. Observera, detta er et tryk — ikke brodyr.',
  },
  rygtryk: {
    title: 'Eksempel rygtryk',
    image: tooltipRyggtryck,
    description: 'En unik design för din klass som trycks på ryggen av tröjan. Du kan välja mellan A4- och A3-format.',
  },
};
